import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../styles'
import { ServiceContentModel } from '../../../types/services/serviceModel'
import { useMediaQuery } from 'react-responsive'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import Link from '../../../components/link/Link'
import { FormattedMessage } from 'react-intl'
import { useHistory } from 'react-router'
import links from '../../../enums/linksEnum'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import { useSelector } from 'react-redux'
import { RootState } from '../../reducers'
import { saveInteractions } from '../../gtm/utils/gtmCallback'

const useStyle = makeStyles(
	(theme) => (
		{
			...styles(theme),
			serviceContainerStyle: {
				position: 'relative',
				width: '100%',

				'& img': {
					position: 'absolute',
					top: 0,
					right: 0
				}
			},
			serviceContainerLargeScreenStyle: {
				paddingTop: 30,

				'& img': {
					width: '40%'
				}
			},
			serviceContainerSmallScreenStyle: {
				paddingTop: 20,

				'& img': {
					width: 135
				}
			},
			serviceTextContainerStyle: {
				backgroundColor: 'white',
				margin: 0,
				boxSizing: 'content-box',

				'& h1': {
					color: theme.palette.blue.main,
					margin: 0,
					marginBottom: 30
				},
				'& p': {
					...styles(theme).text3_opacity,
					color: theme.palette.blue.main,
					margin: 0
				},
				'& div[class^="col-xs"]': {
					padding: 0
				}
			},
			serviceTextContainerLargeScreenStyle: {
				padding: '41px 0 69px 63px',
				height: 200,

				'& h1': {
					...styles(theme).title2
				},
				'& a': {
					marginTop: 33
				}
			},
			serviceTextContainerSmallScreenStyle: {
				padding: '20px 0 35px 30px',
				height: 250,

				'& h1': {
					...styles(theme).title3
				}
			},
			buttonStyle: {
				position: 'absolute',
				right: 0,
				bottom: 0,
				...styles(theme).flex,

				'& svg': {
					padding: 12,
					fill: 'white',
					cursor: 'pointer'
				},
				'& svg:first-child': {
					backgroundColor: theme.palette.blue.main
				},
				'& svg:last-child': {
					backgroundColor: theme.palette.dynamic.main
				}
			}
		}
	)
)

interface AcceptingProps {
	service: ServiceContentModel,
	changeSlide: (direction: 'previous' | 'next') => void
}

type ServiceCardProps = AcceptingProps

const ServiceCard: React.FC<ServiceCardProps> = (
	{
		service,
		changeSlide
	}
) => {
	const classes = useStyle()
	const history = useHistory()
	const maxLength = service.title.length > 20 ? 180 - (service.title.length * 2) : 180
	const nbServices = useSelector((state: RootState) => state.services.content.length)
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const serviceContainerClass: ClassValue = classNames(
		classes.serviceContainerStyle,
		isLargeScreen ? classes.serviceContainerLargeScreenStyle : classes.serviceContainerSmallScreenStyle
	)

	const serviceTextContainerClass: ClassValue = classNames(
		'row',
		classes.serviceTextContainerStyle,
		isLargeScreen ? classes.serviceTextContainerLargeScreenStyle : classes.serviceTextContainerSmallScreenStyle
	)

	const redirectToDetail = () => {
		saveInteractions(
			{
				category: 'Tableau de bord',
				action: 'Blocs de mise en avant',
				label: `Services::${service.title}`
			}
		)

		history.push(`${links.services}/${service.id}`)
	}

	const cutStringKeepingWord = (text: string) => {
		let trimmedString = text.substr(0, maxLength)

		return `${trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(' ')))}...`
	}

	return (
		<div className={serviceContainerClass}>
			<img
				src={service.picture}
				alt={service.alternative_text || 'Service pic'}
			/>

			<div className={serviceTextContainerClass}>
				<div className="col-xs-6">
					<h1>{service.title}</h1>

					<p>{service.hook.length > maxLength ? cutStringKeepingWord(service.hook) : service.hook}</p>

					<Link
						color="colorAccessibility"
						textStyle="text8"
						onClick={redirectToDetail}
					>
						<FormattedMessage
							id="app.details"
							defaultMessage="En savoir plus"
							description="Link description"
						/>
					</Link>
				</div>

				{
					nbServices > 1 &&

					<div className={classes.buttonStyle}>
						<KeyboardArrowLeftIcon onClick={() => changeSlide('previous')} />

						<KeyboardArrowRightIcon onClick={() => changeSlide('next')} />
					</div>
				}
			</div>
		</div>
	)
}

export default ServiceCard
